<template>
  <div class="room-header">
    <div class="phone-call-container">
      <el-button
          class="phone-btn"
          type="text"
          @click="handlePhoneCall"
      >
        <i class="el-icon-phone"></i>
      </el-button>
    </div>

    <el-dialog
        :visible.sync="showPhoneDialog"
        width="400px"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        append-to-body
        custom-class="phone-dialog"
        :close-on-press-escape="false"
        :show-close="false"
    >
      <div class="dialog-header">
        <div class="window-controls">
          <div class="window-close" @click="closeDialog">
            <i class="el-icon-close"></i>
          </div>
        </div>
      </div>
      <div class="phone-dialog-content">
        <div class="user-list">
          <div
              v-for="user in room.users"
              :key="user.id"
              class="user-avatar"
              :class="{ 'active': user._id === myId }"
          >
            <img v-if="user.avatar" :src="user.avatar" alt="用户头像">
            <i v-else class="el-icon-user-solid"></i>
            <div
                v-if="user._id !== myId"
                class="invite-icon"
                @click="inviteUser(user._id)"
            >
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </div>
        <!--        <div class="call-status">-->
        <!--          {{-->
        <!--                callStatus === 'dialing' ? '正在等待对方接听...' :-->
        <!--                    callStatus === 'ringing' ? '收到来电，是否接听？' :-->
        <!--                        '正在通话中...'-->
        <!--          }}-->
        <!--        </div>-->
        <!--        <div class="call-controls">-->
        <!--          <template v-if="callStatus === 'dialing'">-->
        <!--            <el-button type="danger" round @click="hangupCall">-->
        <!--              <i class="el-icon-phone"></i> 挂断-->
        <!--            </el-button>-->
        <!--          </template>-->
        <!--          <template v-else-if="callStatus === 'ringing'">-->
        <!--            <el-button type="success" round @click="answerCall">-->
        <!--              <i class="el-icon-phone"></i> 接听-->
        <!--            </el-button>-->
        <!--            <el-button type="danger" round @click="cancelCall">-->
        <!--              <i class="el-icon-phone"></i> 拒接-->
        <!--            </el-button>-->
        <!--          </template>-->
        <!--          <template v-else>-->
        <!--            <el-button type="danger" round @click="hangupCall">-->
        <!--              <i class="el-icon-phone"></i> 挂断-->
        <!--            </el-button>-->
        <!--          </template>-->
        <!--        </div>-->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'RoomsHeader',

  data() {
    return {
      data: null,
      showPhoneDialog: false,
      callStatus: 'connected' // 新增：dialing|ringing|connected|disconnected
    }
  },

  methods: {
    handlePhoneCall() {
      this.showPhoneDialog = true
      // this.callStatus = 'connected'
    },
    receiveCall(data) {
      this.data = data
      this.$confirm('收到来电邀请，是否接听？', '提示', {
        confirmButtonText: '加入',
        cancelButtonText: '忙碌',
        type: 'warning'
      }).then(() => {
        this.showPhoneDialog = true
        // this.callStatus = 'connected'
        // 这里可以添加接听后的逻辑
      }).catch(() => {
        // this.callStatus = 'disconnected'
        // 这里可以添加拒接后的逻辑
      })
    },
    // answerCall(isCaller = false) {
    //   //  this.callStatus = 'connected'
    //   // 这里可以添加接听后的逻辑
    //   if (!isCaller) {
    //     this.handleOffer(this.data)
    //   }
    // },
    cancelCall() {
      this.showPhoneDialog = false
      // this.callStatus = 'disconnected'
    },
    hangupCall() {
      this.showPhoneDialog = false
      // this.callStatus = 'disconnected'
      // 这里可以添加挂断后的逻辑
      this.hangup()
    },
    inviteUser(userId) {
      this.$confirm('确认邀请该用户加入通话吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //    this.callStatus = 'ringing'
        // 这里可以添加邀请用户的逻辑
        this.inviteToCall(userId, this.room)
      }).catch(() => {
        // 用户取消操作
      })
    },
    closeDialog() {
      this.$confirm('确认退出通话吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.showPhoneDialog = false
        this.hangup(this.room) // 如果需要在关闭时挂断通话
      }).catch(() => {
        // 用户取消操作
      })
    }
  },
  props: {
    myId: {
      type: String,
      default: null
    },
    room: {
      type: Object,
      default: null
    },
    hangup: {
      type: Function,
      default: null
    },
    inviteToCall: {
      type: Function,
      default: null
    },
  }
}
</script>

<style scoped>
.phone-call-container {
  display: flex;
  align-items: center;
}

.phone-btn {
  font-size: 20px;
  color: #409EFF;
}

.phone-btn:hover {
  color: #79bbff;
}

.phone-btn i {
  font-size: 20px;
}

.phone-dialog .el-dialog__body {
  min-height: 200px; /* 减小最小高度 */
  padding: 20px;
}

.phone-dialog-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 30px 0;
}

.call-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.call-avatar i {
  font-size: 60px;
  color: #909399;
}

.call-status {
  font-size: 16px;
  color: #606266;
  margin: 20px 0;
}

.call-controls {
  margin-top: auto;
  display: flex;
  gap: 10px;
}

.call-controls .el-button {
  padding: 12px 30px;
}

.call-controls i {
  transform: rotate(135deg);
  margin-right: 5px;
}

.call-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.user-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}

.user-avatar {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
}

.user-avatar.active {
  opacity: 1;
}

.invite-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #409EFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 1; /* 新增：覆盖父元素的透明度 */
}

.user-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.invite-icon i {
  color: white;
  font-size: 12px;
}

.dialog-header {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
}

.window-controls {
  display: flex;
  gap: 8px;
}

.window-close {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ff5f56;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.window-close i {
  color: white;
  font-size: 8px;
  visibility: hidden;
}

.window-close:hover i {
  visibility: visible;
}
</style>
